import { isEmpty, isNil } from 'lodash/fp';
import pt from 'prop-types';
import { Children, forwardRef, useEffect, useMemo } from 'react';
import { mapIndexed } from '@mews-commander/utils';
import { CornerCellElement, MatrixAsideWrapperElement } from '../styles';
import { renderOuterCell } from '../utils';

const renderAsideCell =
    ({ parentNestedIndex, cellHeight, cellWidth, depth = 0, expanded, setExpanded }: $TSFixMe) =>
    (asideCell: $TSFixMe, asideCellIndex: $TSFixMe) => {
        const { subCells = [] } = asideCell.props;

        const hasChildren = !isEmpty(subCells);
        const currentNestedIndex = parentNestedIndex
            ? `${parentNestedIndex}.${asideCellIndex}`
            : asideCellIndex.toString();
        const isCurrentAsideCellExpanded = expanded[currentNestedIndex];

        return (
            <>
                {renderOuterCell({
                    cellHeight,
                    cellWidth,
                    depth,
                    hasChildren,
                    isExpanded: expanded[currentNestedIndex],
                    key: `aside-cell-${currentNestedIndex}`,
                    nestedIndex: currentNestedIndex,
                    toggleCollapse: () => (hasChildren ? setExpanded(currentNestedIndex) : null),
                })(asideCell, asideCellIndex)}
                {isCurrentAsideCellExpanded
                    ? mapIndexed(
                          renderAsideCell({
                              cellHeight,
                              cellWidth,
                              depth: depth + 1,
                              expanded,
                              parentNestedIndex: currentNestedIndex,
                              setExpanded,
                          }),
                          subCells
                      )
                    : null}
            </>
        );
    };

interface MatrixAsideFactoryParams {
    CornerCell: React.ElementType;
    MatrixAsideWrapper: React.ElementType;
}

export const matrixAsideFactory = (params?: MatrixAsideFactoryParams) => {
    const { CornerCell = CornerCellElement, MatrixAsideWrapper = MatrixAsideWrapperElement } = params ?? {};

    const MatrixAside = forwardRef<$TSFixMe, React.PropsWithChildren<{}>>(
        (
            {
                // @ts-expect-error $TSFixMeError: Property 'cellHeight' does not exist on type '{ children?: ReactNode; }'.
                cellHeight,
                children,
                // @ts-expect-error $TSFixMeError: Property 'cornerCellHeight' does not exist on type '{ children?: ReactNode; }'.
                cornerCellHeight,
                // @ts-expect-error $TSFixMeError: Property 'expanded' does not exist on type '{ children?: ReactNode; }'.
                expanded,
                // @ts-expect-error $TSFixMeError: Property 'height' does not exist on type '{ children?: ReactNode; }'.
                height,
                // @ts-expect-error $TSFixMeError: Property 'scrollPosition' does not exist on type '{ children?: ReactNode; }'.
                scrollPosition,
                // @ts-expect-error $TSFixMeError: Property 'setExpanded' does not exist on type '{ children?: ReactNode; }'.
                setExpanded,
                // @ts-expect-error $TSFixMeError: Property 'width' does not exist on type '{ children?: ReactNode; }'.
                width,
                ...asideProps
            },
            ref
        ) => {
            useEffect(() => {
                if (!isNil((ref as $TSFixMe).current)) {
                    (ref as $TSFixMe).current.scrollTop = scrollPosition;
                }
            }, [ref, scrollPosition]);

            const asideCells = useMemo(() => {
                if (isEmpty(children)) {
                    return null;
                }

                return Children.map(children, renderAsideCell({ cellHeight, cellWidth: width, expanded, setExpanded }));
            }, [children, cellHeight, expanded, width, setExpanded]);

            return asideCells ? (
                <div>
                    <CornerCell height={cornerCellHeight} />
                    <MatrixAsideWrapper height={height} ref={ref} width={width} {...asideProps}>
                        {asideCells}
                    </MatrixAsideWrapper>
                </div>
            ) : null;
        }
    );

    MatrixAside.propTypes = {
        // @ts-expect-error $TSFixMeError: Type '{ cellHeight: pt.Requireable<number | (number | null)[]>; cellWidth: pt.Requireable<number>; children: pt.Requirea...
        cellHeight: pt.oneOfType([pt.number, pt.arrayOf(pt.number)]),
        cellWidth: pt.number,
        children: pt.node,
        expanded: pt.shape({}),
        setExpanded: pt.func,
        scrollPosition: pt.number,
        topMargin: pt.number,
        width: pt.number,
    };

    return MatrixAside;
};

export default matrixAsideFactory();
